import { toast, ToastOptions } from 'react-toastify';
import CustomToast from '../components/Toast/CustomToast';
import '../assets/css/custom-toast.css';

const defaultOptions: ToastOptions = {
  position: 'top-center',
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  closeButton: true,
  icon: false,
  className: 'custom-toast',
  style: {
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    width: '450px',
    maxWidth: '90vw',
  },
};


export const showSuccessToast = (
  title: string,
  description?: string,
  options?: ToastOptions
) => {
  toast.success(<CustomToast title={title} description={description} type="success" />, {
    ...defaultOptions,
    ...options,
  });
};

export const showErrorToast = (
  title: string,
  description?: string,
  options?: ToastOptions
) => {
  toast.error(<CustomToast title={title} description={description} type="error" />, {
    ...defaultOptions,
    ...options,
  });
};

export const showInfoToast = (
  title: string,
  description?: string,
  options?: ToastOptions
) => {
  toast.info(<CustomToast title={title} description={description} type="success" />, {
    ...defaultOptions,
    ...options,
  });
};
